exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadDoc[data-v-5c18b67a] .el-upload{width:100%!important}.uploadDoc[data-v-5c18b67a] .el-upload-dragger{width:100%!important;height:230px!important}", ""]);

// exports
